// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./utils.res.js");

function MultipleTextInput(props) {
  var __containerClassName = props.containerClassName;
  var labelCSS = props.labelCSS;
  var maxLength = props.maxLength;
  var __error = props.error;
  var errorText = props.errorText;
  var errorCSS = props.errorCSS;
  var handleChange = props.handleChange;
  var tags = props.tags;
  var error = __error !== undefined ? __error : false;
  var containerClassName = __containerClassName !== undefined ? __containerClassName : "flex justify-between items-center";
  var match = React.useState(function (param) {
        return "";
      });
  var setInputValue = match[1];
  var inputValue = match[0];
  var maximumLength = maxLength !== undefined ? maxLength : 524288;
  var handleKeyDown = function ($$event) {
    var value = inputValue.trim();
    if (!($$event.key === "Enter" && value !== "")) {
      return ;
    }
    $$event.preventDefault();
    if (Belt_List.has(tags, value, (function (a, b) {
              return a === b;
            }))) {
      return ;
    }
    var updatedTags = List.append(tags, {
          hd: value,
          tl: /* [] */0
        });
    Curry._1(setInputValue, (function (param) {
            return "";
          }));
    Curry._1(handleChange, updatedTags);
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: labelCSS !== undefined ? labelCSS : "text-sm font-medium " + Belt_Option.getWithDefault(props.labelClassName, "")
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: "w-full border-none outline-none",
                              maxLength: maximumLength,
                              placeholder: "Type and press Enter",
                              type: "text",
                              value: inputValue,
                              onKeyDown: handleKeyDown,
                              onChange: (function (e) {
                                  Curry._1(setInputValue, Utils$ReactHooksTemplate.formTargetValue(e));
                                })
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.mapWithIndex(tags, (function (index, tag) {
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        tag,
                                                        JsxRuntime.jsx("button", {
                                                              children: "x",
                                                              className: "ml-1 text-gray-600 hover:text-red-500",
                                                              onClick: (function (param) {
                                                                  Curry._1(handleChange, Belt_List.keepWithIndex(tags, (function (param, i) {
                                                                              return index !== i;
                                                                            })));
                                                                })
                                                            })
                                                      ],
                                                      className: "flex items-center bg-gray-200 text-sm px-2 py-1 rounded-lg break-all"
                                                    }, String(index + 1 | 0));
                                        }))),
                              className: "flex flex-wrap gap-2 max-h-8-rem overflow-y-auto mt-1"
                            }),
                        error ? JsxRuntime.jsx("div", {
                                children: errorText !== undefined ? errorText : "Error",
                                className: errorCSS !== undefined ? errorCSS : "text-red-600 font-medium float-right"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "border border-gray-400 px-3 py-2 rounded text-sm max-h-12-rem"
                    })
              ],
              className: containerClassName
            });
}

var make = MultipleTextInput;

exports.make = make;
/* react Not a pure module */
